import styles from './SettingLeftMenu.module.scss';
import clsx from 'clsx';
import MenuItem from '@/components/channel/pc/layout/LeftMenu/Setting/MenuItem';
import MenuContextList from '@/components/channel/pc/layout/LeftMenu/Setting/MenuContextList';
import {useDeviceDetection} from '@/hooks/channel/useDeviceDetection';
import useGlobalUIStore from '@/stores';
import {RouterLink} from '@/components/channel/common/RouterLink';
import {ROUTE} from '@/constants/main/route';
import {SoopButtonIcon, SoopImage} from '@soop-ui/soop-ui';
import {useStationData} from '@/stores/channel/station';
import {useStationUser} from '@/stores/channel/station';

const ChannelSettingLeftMenu = () => {
  // Lnb 메뉴는 main 밖에 있기 때문에, reactQuery X, store로 사용
  const {station} = useStationData();
  const {userPermissions} = useStationUser();
  const {isDarkMode, isLnbOpened} = useGlobalUIStore();

  // 작은 해상도에서 노출되는 햄버거 메뉴 클릭 시 : 이건 공통GNB와 별개로 구현된 부분이라 어쩔 수 없다.
  const handleLnbClose = () => {
    document
      .querySelector<HTMLButtonElement>('#topInnerHeader .btn_flexible button')
      ?.click();
  };

  const {userId: streamerId, nickname: streamerNickname} =
    station?.detail || {};

  const {isOwner, isManager} = userPermissions || {};

  const deviceType = useDeviceDetection('userAgent');

  return (
    streamerId &&
    deviceType === 'pc' &&
    (isOwner || isManager) && (
      <div
        className={clsx(styles.settingLeftMenuWrapper, {
          [styles.expanded]: isLnbOpened,
          [styles.contracted]: !isLnbOpened,
        })}>
        <div className={styles.sidebarHeader}>
          <SoopButtonIcon
            circle
            iconName='icoSwitch'
            size={40}
            className={styles.fixBtn}
            startIconName='icoEmoticon'
            variant='clearPrimary'
            onClick={handleLnbClose}
          />
          <RouterLink
            name={ROUTE.CHANNEL.SERVICE.HOME}
            params={{streamerId: streamerId || ''}}>
            <SoopImage
              src={
                !isDarkMode
                  ? '//res.sooplive.co.kr/images/svg/soop_logo.svg'
                  : '//res.sooplive.co.kr/images/svg/soop_logo_dark.svg'
              }
              alt='SOOP'
            />
          </RouterLink>
        </div>
        <div className={styles.dimmed} onClick={handleLnbClose}></div>
        <div className={styles.innerLnb}>
          <div className={clsx(styles.menuBox)}>
            <MenuItem
              streamerId={streamerId}
              nickname={streamerNickname || streamerId}
            />
            <MenuItem
              menuName={'방송국 관리'}
              iconName={'icoChannelEdit' as any}
            />
            <MenuContextList
              isManager={isManager ?? false}
              streamerId={streamerId}
              menuType={'channelSetting'}
            />
            <MenuItem
              menuName={'유저 / 권한 관리'}
              iconName={'icoUserManagement'}
            />
            <MenuContextList
              isManager={isManager ?? false}
              streamerId={streamerId}
              menuType={'userAuthSetting'}
            />

            {isOwner && (
              <>
                <MenuItem
                  menuName={'수익 / 활동 내역'}
                  iconName={'icoActivityManagement'}
                />
                <MenuContextList
                  isManager={isManager ?? false}
                  streamerId={streamerId}
                  menuType={'activeHistory'}
                />
                <MenuItem
                  menuName={'VOD 광고 관리'}
                  iconName={'icoVodAdSetting'}
                />
                <MenuContextList
                  isManager={isManager ?? false}
                  streamerId={streamerId}
                  menuType={'advertiseSetting'}
                />
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default ChannelSettingLeftMenu;
